document.addEventListener('DOMContentLoaded', function() {
  
  // ========================================
  // SIDEBAR CATEGORY SWITCHING
  // ========================================
  const sidebarLinks = document.querySelectorAll('.sidebar-navlink[data-category-handle]');
  const categoryContents = document.querySelectorAll('.category-content');
  
  // Show first category by default
  if (categoryContents.length > 0) {
    categoryContents.forEach(content => content.classList.remove('category-content--active'));
    categoryContents[0].classList.add('category-content--active');
  }
  
  // Switch content when hovering over sidebar links
  sidebarLinks.forEach(link => {
    link.addEventListener('mouseenter', function(e) {
      e.preventDefault();
      const categoryHandle = this.getAttribute('data-category-handle');
      
      // Update active states for sidebar
      sidebarLinks.forEach(l => l.classList.remove('sidebar-navlink--active'));
      this.classList.add('sidebar-navlink--active');
      
      // Show corresponding content
      categoryContents.forEach(content => {
        content.classList.remove('category-content--active');
        if (content.id === 'content-' + categoryHandle) {
          content.classList.add('category-content--active');
          
          // Initialize first main category in this content
          const firstMainCategory = content.querySelector('.main-category-link');
          if (firstMainCategory) {
            // Trigger hover on first main category
            setTimeout(() => {
              firstMainCategory.classList.add('active');
              const firstHandle = firstMainCategory.getAttribute('data-main-category');
              const firstSubgroup = content.querySelector('#subgroup-' + firstHandle);
              if (firstSubgroup) {
                // Hide all subgroups in this content
                content.querySelectorAll('.subcategory-group').forEach(g => g.classList.remove('active'));
                firstSubgroup.classList.add('active');
              }
            }, 50);
          }
        }
      });
    });
  });
  
  // ========================================
  // MAIN CATEGORY HOVER SWITCHING
  // ========================================
  const mainCategoryLinks = document.querySelectorAll('.main-category-link');
  
  mainCategoryLinks.forEach(link => {
    link.addEventListener('mouseenter', function(e) {
      e.preventDefault();
      const mainCategoryHandle = this.getAttribute('data-main-category');
      
      // Find the parent category-content
      const parentContent = this.closest('.category-content');
      if (!parentContent) return;
      
      // Update active states for main categories in this content only
      const siblingLinks = parentContent.querySelectorAll('.main-category-link');
      siblingLinks.forEach(l => l.classList.remove('active'));
      this.classList.add('active');
      
      // Show corresponding subcategory group
      const subcategoryGroups = parentContent.querySelectorAll('.subcategory-group');
      subcategoryGroups.forEach(group => group.classList.remove('active'));
      
      const targetSubgroup = parentContent.querySelector('#subgroup-' + mainCategoryHandle);
      if (targetSubgroup) {
        targetSubgroup.classList.add('active');
      }
    });
  });
  
  // ========================================
  // INITIALIZE FIRST ITEMS ON PAGE LOAD
  // ========================================
  
  // Activate first sidebar category
  if (sidebarLinks.length > 0) {
    sidebarLinks[0].classList.add('sidebar-navlink--active');
  }
  
  // Activate first main category in first visible content
  const firstVisibleContent = document.querySelector('.category-content--active');
  if (firstVisibleContent) {
    const firstMainCategory = firstVisibleContent.querySelector('.main-category-link');
    if (firstMainCategory) {
      firstMainCategory.classList.add('active');
      
      const firstHandle = firstMainCategory.getAttribute('data-main-category');
      const firstSubgroup = firstVisibleContent.querySelector('#subgroup-' + firstHandle);
      if (firstSubgroup) {
        firstSubgroup.classList.add('active');
      }
    }
  }
  
  // ========================================
  // OPTIONAL: CLOSE MEGA MENU ON OUTSIDE CLICK
  // ========================================
  document.addEventListener('click', function(e) {
    const megaMenus = document.querySelectorAll('.mega-menu-fullwidth');
    const menuItems = document.querySelectorAll('.menu__item');
    
    // Check if click is outside all mega menus and menu items
    let isOutside = true;
    megaMenus.forEach(menu => {
      if (menu.contains(e.target)) isOutside = false;
    });
    menuItems.forEach(item => {
      if (item.contains(e.target)) isOutside = false;
    });
    
    if (isOutside) {
      // Close all mega menus
      document.querySelectorAll('hover-disclosure[aria-expanded="true"]').forEach(disclosure => {
        disclosure.setAttribute('aria-expanded', 'false');
      });
    }
  });
  
});


// Mobile naigation multi 

